export default "__VITE_ASSET__11bf3cbb__"